// Auto-generated: Nebraska ZIP -> lat/lng lookup
// Do NOT edit by hand; run src/scripts/buildNebraskaZipCoords.mjs again if needed.

const ZIP_COORDS = {
  "68666": { lat: 41.11091, lng: -97.61556 },
  "68516": { lat: 40.73488, lng: -96.64258 },
  "68765": { lat: 42.34268, lng: -97.62229 },
  "68733": { lat: 42.28484, lng: -96.72476 },
  "68743": { lat: 42.46556, lng: -96.62619 },
  "69219": { lat: 42.70609, lng: -101.10082 },
  "68048": { lat: 40.98141, lng: -95.9344 },
  "68402": { lat: 40.90778, lng: -96.85713 },
  "68342": { lat: 40.10069, lng: -96.94431 },
  "68661": { lat: 41.49315, lng: -97.08361 },
  "68971": { lat: 40.11797, lng: -99.24414 },
  "68644": { lat: 41.71033, lng: -97.6752 },
  "68020": { lat: 41.97579, lng: -96.25927 },
  "68785": { lat: 42.42647, lng: -96.72412 },
  "68073": { lat: 41.25066, lng: -96.40779 },
  "68423": { lat: 40.80269, lng: -96.95214 },
  "68460": { lat: 40.89459, lng: -97.43027 },
  "68039": { lat: 42.11408, lng: -96.34461 },
  "68771": { lat: 42.38321, lng: -97.35756 },
  "68768": { lat: 41.99445, lng: -97.06757 },
  "68814": { lat: 41.31652, lng: -99.41292 },
  "68946": { lat: 40.11166, lng: -99.98577 },
  "69141": { lat: 41.30645, lng: -102.95494 },
  "68069": { lat: 41.24286, lng: -96.31621 },
  "68335": { lat: 40.27698, lng: -97.80302 },
  "68102": { lat: 41.26204, lng: -95.93306 },
  "68046": { lat: 41.12488, lng: -96.05945 },
  "68758": { lat: 41.78651, lng: -97.78843 },
  "68064": { lat: 41.35106, lng: -96.34991 },
  "68417": { lat: 40.73642, lng: -96.08861 },
  "68972": { lat: 40.10787, lng: -98.80645 },
  "68663": { lat: 41.31669, lng: -97.69469 },
  "68741": { lat: 42.34861, lng: -96.59047 },
  "68929": { lat: 40.14998, lng: -99.05112 },
  "68343": { lat: 40.61869, lng: -97.13424 },
  "68446": { lat: 40.65328, lng: -96.17511 },
  "68769": { lat: 42.32227, lng: -97.81212 },
  "68072": { lat: 41.60917, lng: -96.50483 },
  "68444": { lat: 40.41138, lng: -97.57706 },
  "68964": { lat: 40.23679, lng: -97.91267 },
  "68952": { lat: 40.07521, lng: -98.66779 },
  "68662": { lat: 41.21054, lng: -97.41406 },
  "68010": { lat: 41.25584, lng: -96.13385 },
  "69340": { lat: 42.21349, lng: -102.20804 },
  "68434": { lat: 40.90874, lng: -97.12035 },
  "69046": { lat: 40.07638, lng: -100.08654 },
  "68626": { lat: 41.16707, lng: -96.99433 },
  "68409": { lat: 40.90812, lng: -95.95152 },
  "68340": { lat: 40.13255, lng: -97.74719 },
  "68452": { lat: 40.39446, lng: -97.85229 },
  "68725": { lat: 42.20223, lng: -98.7771 },
  "69361": { lat: 41.9246, lng: -103.62167 },
  "69151": { lat: 41.0982, lng: -100.50409 },
  "69339": { lat: 42.59536, lng: -103.40799 },
  "68019": { lat: 41.78424, lng: -96.37371 },
  "68134": { lat: 41.29854, lng: -96.05065 },
  "68442": { lat: 40.23865, lng: -95.77321 },
  "68629": { lat: 41.71607, lng: -97.12874 },
  "68751": { lat: 42.6906, lng: -96.98083 },
  "68669": { lat: 41.0825, lng: -97.23467 },
  "68831": { lat: 41.11096, lng: -98.55389 },
  "68380": { lat: 40.24083, lng: -96.39323 },
  "68331": { lat: 40.472, lng: -96.71059 },
  "69143": { lat: 41.21012, lng: -101.0392 },
  "69144": { lat: 41.29013, lng: -101.58233 },
  "68869": { lat: 40.99689, lng: -98.88117 },
  "68850": { lat: 40.82956, lng: -99.73645 },
  "69028": { lat: 40.63536, lng: -100.05634 },
  "68057": { lat: 41.6596, lng: -96.7192 },
  "68350": { lat: 40.04461, lng: -97.0763 },
  "68739": { lat: 42.62568, lng: -97.26945 },
  "69168": { lat: 40.79934, lng: -101.98656 },
  "68017": { lat: 41.05951, lng: -96.65487 },
  "68345": { lat: 40.03993, lng: -96.028 },
  "68428": { lat: 40.96968, lng: -96.79448 },
  "68853": { lat: 41.29253, lng: -98.98826 },
  "68923": { lat: 40.35909, lng: -99.46833 },
  "68717": { lat: 42.39463, lng: -97.21934 },
  "68104": { lat: 41.29498, lng: -96.00128 },
  "69210": { lat: 42.37775, lng: -99.90853 },
  "69034": { lat: 40.2486, lng: -100.43074 },
  "68355": { lat: 40.11509, lng: -95.56406 },
  "68430": { lat: 40.66862, lng: -96.66342 },
  "68956": { lat: 40.63459, lng: -98.69256 },
  "68981": { lat: 40.281, lng: -98.89665 },
  "69337": { lat: 42.82654, lng: -103.01091 },
  "68855": { lat: 41.1678, lng: -99.32387 },
  "68420": { lat: 40.09409, lng: -96.20202 },
  "68457": { lat: 40.15328, lng: -95.70736 },
  "68720": { lat: 42.34562, lng: -98.01261 },
  "69130": { lat: 40.88948, lng: -99.95734 },
  "68718": { lat: 42.65594, lng: -97.69676 },
  "69125": { lat: 41.61648, lng: -102.83343 },
  "69140": { lat: 40.85087, lng: -101.78039 },
  "69150": { lat: 40.84769, lng: -101.54353 },
  "68748": { lat: 41.84007, lng: -97.46471 },
  "69024": { lat: 40.23235, lng: -100.85151 },
  "68108": { lat: 41.23741, lng: -95.93055 },
  "68328": { lat: 40.47743, lng: -96.83764 },
  "68835": { lat: 41.33176, lng: -98.6199 },
  "68325": { lat: 40.01683, lng: -97.75788 },
  "68503": { lat: 40.82458, lng: -96.67403 },
  "68747": { lat: 42.39443, lng: -97.49721 },
  "68932": { lat: 40.30849, lng: -98.72519 },
  "68337": { lat: 40.09667, lng: -95.83811 },
  "68922": { lat: 40.33395, lng: -99.89664 },
  "69171": { lat: 40.89006, lng: -100.07072 },
  "69341": { lat: 41.73123, lng: -103.67304 },
  "68007": { lat: 41.3698, lng: -96.1914 },
  "68958": { lat: 40.52237, lng: -99.50139 },
  "68371": { lat: 40.77226, lng: -97.78919 },
  "68361": { lat: 40.50993, lng: -97.60023 },
  "68967": { lat: 40.25369, lng: -99.62433 },
  "68303": { lat: 40.26603, lng: -97.422 },
  "68638": { lat: 41.37421, lng: -97.9868 },
  "68370": { lat: 40.13915, lng: -97.55057 },
  "68514": { lat: 40.92554, lng: -96.65156 },
  "68008": { lat: 41.54785, lng: -96.16351 },
  "68727": { lat: 42.513, lng: -97.20348 },
  "68863": { lat: 40.76972, lng: -99.52494 },
  "68329": { lat: 40.50243, lng: -96.16245 },
  "68018": { lat: 41.30538, lng: -96.61232 },
  "69020": { lat: 40.22083, lng: -100.30358 },
  "69352": { lat: 41.80064, lng: -103.97065 },
  "68359": { lat: 40.62958, lng: -97.28532 },
  "69360": { lat: 42.69945, lng: -102.47171 },
  "68016": { lat: 41.04333, lng: -96.10424 },
  "68433": { lat: 40.05169, lng: -95.73584 },
  "68975": { lat: 40.62041, lng: -97.95379 },
  "68132": { lat: 41.26466, lng: -96.00236 },
  "68935": { lat: 40.3779, lng: -97.9574 },
  "68322": { lat: 40.33882, lng: -97.55624 },
  "69029": { lat: 40.70961, lng: -100.25091 },
  "68118": { lat: 41.26318, lng: -96.17743 },
  "68138": { lat: 41.15606, lng: -96.13645 },
  "68055": { lat: 42.05893, lng: -96.47216 },
  "69027": { lat: 40.42736, lng: -101.53668 },
  "68135": { lat: 41.20569, lng: -96.19552 },
  "69334": { lat: 41.82583, lng: -103.28838 },
  "68632": { lat: 41.24724, lng: -97.13113 },
  "68648": { lat: 41.40459, lng: -96.79161 },
  "68701": { lat: 42.02136, lng: -97.44362 },
  "68846": { lat: 41.06653, lng: -97.88675 },
  "68376": { lat: 40.17438, lng: -95.945 },
  "69358": { lat: 42.06784, lng: -103.96709 },
  "69044": { lat: 40.12824, lng: -101.02252 },
  "69132": { lat: 40.85684, lng: -100.98323 },
  "68665": { lat: 41.76102, lng: -98.40606 },
  "68110": { lat: 41.29845, lng: -95.91168 },
  "68844": { lat: 41.05991, lng: -99.05857 },
  "68439": { lat: 41.00107, lng: -97.20883 },
  "68875": { lat: 41.56285, lng: -98.66741 },
  "69353": { lat: 41.74715, lng: -103.41677 },
  "68874": { lat: 41.63752, lng: -99.41287 },
  "68823": { lat: 41.92648, lng: -99.10901 },
  "68381": { lat: 40.08011, lng: -96.48041 },
  "68960": { lat: 40.10088, lng: -99.13731 },
  "68944": { lat: 40.64372, lng: -98.09094 },
  "68728": { lat: 42.37634, lng: -96.95269 },
  "69212": { lat: 42.93681, lng: -100.79259 },
  "68002": { lat: 41.49691, lng: -96.33704 },
  "69351": { lat: 42.03702, lng: -102.41872 },
  "68415": { lat: 40.06372, lng: -96.8205 },
  "68424": { lat: 40.29705, lng: -97.01681 },
  "69357": { lat: 42.07536, lng: -103.81427 },
  "68810": { lat: 40.85843, lng: -98.46696 },
  "68980": { lat: 40.68125, lng: -98.25261 },
  "69356": { lat: 41.89476, lng: -103.45129 },
  "68352": { lat: 40.1458, lng: -97.22032 },
  "68925": { lat: 40.4254, lng: -98.43785 },
  "69131": { lat: 41.40732, lng: -102.97355 },
  "69170": { lat: 40.79808, lng: -100.7415 },
  "68784": { lat: 42.25777, lng: -96.8929 },
  "69040": { lat: 40.35016, lng: -101.12728 },
  "68114": { lat: 41.26324, lng: -96.05206 },
  "68961": { lat: 40.20518, lng: -98.03851 },
  "68028": { lat: 41.10634, lng: -96.26083 },
  "68307": { lat: 40.78983, lng: -96.1336 },
  "68836": { lat: 40.70649, lng: -99.3743 },
  "69032": { lat: 40.55803, lng: -101.02052 },
  "69149": { lat: 41.21545, lng: -102.67597 },
  "68659": { lat: 41.54493, lng: -96.94331 },
  "68309": { lat: 40.06006, lng: -96.56862 },
  "68403": { lat: 40.92071, lng: -96.16801 },
  "68640": { lat: 41.46285, lng: -97.77395 },
  "68344": { lat: 40.56985, lng: -96.40066 },
  "68601": { lat: 41.45254, lng: -97.40235 },
  "68116": { lat: 41.29935, lng: -96.16782 },
  "69142": { lat: 41.91574, lng: -100.3172 },
  "68770": { lat: 42.56422, lng: -96.76512 },
  "68926": { lat: 40.0948, lng: -99.84767 },
  "68510": { lat: 40.80652, lng: -96.63597 },
  "68767": { lat: 42.1996, lng: -97.55184 },
  "68957": { lat: 40.2665, lng: -98.2372 },
  "68943": { lat: 40.04888, lng: -97.89868 },
  "69045": { lat: 40.47285, lng: -101.37369 },
  "68722": { lat: 42.9202, lng: -98.87406 },
  "68817": { lat: 41.27394, lng: -98.79087 },
  "68824": { lat: 40.99226, lng: -98.60166 },
  "68959": { lat: 40.48589, lng: -98.91426 },
  "68901": { lat: 40.59293, lng: -98.37284 },
  "68061": { lat: 41.79941, lng: -96.21152 },
  "69217": { lat: 42.38756, lng: -99.71404 },
  "69145": { lat: 41.2465, lng: -103.67052 },
  "68130": { lat: 41.23422, lng: -96.19586 },
  "68152": { lat: 41.36536, lng: -95.99789 },
  "68528": { lat: 40.82024, lng: -96.81943 },
  "68803": { lat: 40.95492, lng: -98.41522 },
  "69220": { lat: 42.90092, lng: -100.18995 },
  "69333": { lat: 42.05948, lng: -101.97264 },
  "68413": { lat: 40.83779, lng: -96.01229 },
  "68622": { lat: 41.94182, lng: -98.58052 },
  "68128": { lat: 41.18135, lng: -96.06582 },
  "69166": { lat: 42.07125, lng: -100.56855 },
  "69163": { lat: 41.56183, lng: -100.57078 },
  "68066": { lat: 41.18598, lng: -96.6243 },
  "68378": { lat: 40.38339, lng: -96.02534 },
  "68418": { lat: 40.69487, lng: -96.38857 },
  "68766": { lat: 42.43498, lng: -98.40574 },
  "68450": { lat: 40.36099, lng: -96.22739 },
  "68445": { lat: 40.38926, lng: -97.07915 },
  "68022": { lat: 41.27845, lng: -96.24594 },
  "68521": { lat: 40.86613, lng: -96.70947 },
  "69221": { lat: 42.59286, lng: -100.3109 },
  "68154": { lat: 41.26475, lng: -96.11565 },
  "68467": { lat: 40.8664, lng: -97.59544 },
  "68038": { lat: 41.95407, lng: -96.44589 },
  "68752": { lat: 42.02716, lng: -97.72844 },
  "68354": { lat: 40.63781, lng: -97.57833 },
  "68443": { lat: 40.45213, lng: -96.36807 },
  "68776": { lat: 42.46058, lng: -96.44131 },
  "68858": { lat: 40.95947, lng: -99.37702 },
  "68966": { lat: 40.14974, lng: -99.46891 },
  "69128": { lat: 41.22199, lng: -103.92135 },
  "68526": { lat: 40.73235, lng: -96.58367 },
  "68949": { lat: 40.42911, lng: -99.38993 },
  "69169": { lat: 40.81753, lng: -101.1691 },
  "68015": { lat: 41.38558, lng: -96.64342 },
  "68825": { lat: 41.27175, lng: -99.96458 },
  "68531": { lat: 40.90141, lng: -96.72324 },
  "68447": { lat: 40.20495, lng: -96.07629 },
  "68713": { lat: 42.53801, lng: -98.96907 },
  "68527": { lat: 40.84711, lng: -96.52423 },
  "68157": { lat: 41.17845, lng: -95.99693 },
  "68318": { lat: 40.15391, lng: -96.6401 },
  "68366": { lat: 40.97385, lng: -96.43815 },
  "68003": { lat: 41.07768, lng: -96.38545 },
  "68326": { lat: 40.28607, lng: -97.68284 },
  "68948": { lat: 40.32004, lng: -100.02192 },
  "68464": { lat: 40.4286, lng: -97.19869 },
  "68045": { lat: 41.8256, lng: -96.49652 },
  "68455": { lat: 40.82569, lng: -95.90087 },
  "68178": { lat: 41.26569, lng: -95.94756 },
  "68870": { lat: 40.85249, lng: -99.16106 },
  "68936": { lat: 40.33137, lng: -99.77505 },
  "68042": { lat: 41.0967, lng: -96.43835 },
  "68465": { lat: 40.49083, lng: -97.02078 },
  "69121": { lat: 41.5665, lng: -101.69469 },
  "68660": { lat: 41.57549, lng: -97.86973 },
  "69101": { lat: 41.14266, lng: -100.80079 },
  "68757": { lat: 42.65025, lng: -96.92136 },
  "68333": { lat: 40.6233, lng: -96.94775 },
  "68781": { lat: 42.02383, lng: -97.86242 },
  "68982": { lat: 40.33233, lng: -99.18016 },
  "69153": { lat: 41.09967, lng: -101.67646 },
  "68976": { lat: 40.58319, lng: -99.72852 },
  "69026": { lat: 40.04677, lng: -100.42967 },
  "68305": { lat: 40.36566, lng: -95.85854 },
  "69154": { lat: 41.43717, lng: -102.34768 },
  "68818": { lat: 40.81762, lng: -98.00833 },
  "68301": { lat: 40.46516, lng: -96.52387 },
  "68753": { lat: 42.88469, lng: -99.44943 },
  "68974": { lat: 40.1324, lng: -97.87189 },
  "68040": { lat: 41.28446, lng: -96.73674 },
  "68878": { lat: 40.97611, lng: -99.51705 },
  "68970": { lat: 40.10883, lng: -98.51522 },
  "68005": { lat: 41.14193, lng: -95.89228 },
  "68940": { lat: 40.55134, lng: -99.24279 },
  "69146": { lat: 41.34411, lng: -101.8176 },
  "68631": { lat: 41.68978, lng: -97.34907 },
  "69347": { lat: 42.60771, lng: -102.67976 },
  "68327": { lat: 40.0282, lng: -97.61814 },
  "68790": { lat: 42.16242, lng: -97.17545 },
  "69023": { lat: 40.48119, lng: -101.90418 },
  "68746": { lat: 42.79222, lng: -98.43848 },
  "68654": { lat: 41.06673, lng: -97.78414 },
  "68933": { lat: 40.51674, lng: -98.02741 },
  "68456": { lat: 40.91123, lng: -97.31435 },
  "68365": { lat: 40.60962, lng: -97.72883 },
  "68635": { lat: 41.08247, lng: -97.01491 },
  "69030": { lat: 40.20562, lng: -101.92311 },
  "68729": { lat: 42.47079, lng: -97.90434 },
  "68653": { lat: 41.55523, lng: -97.48529 },
  "68842": { lat: 41.56757, lng: -98.50057 },
  "68164": { lat: 41.29905, lng: -96.10955 },
  "68761": { lat: 42.05446, lng: -97.96181 },
  "68063": { lat: 41.73059, lng: -96.49563 },
  "68147": { lat: 41.1761, lng: -95.95671 },
  "68623": { lat: 41.44401, lng: -98.15026 },
  "68714": { lat: 42.40228, lng: -99.4864 },
  "68832": { lat: 40.76667, lng: -98.36573 },
  "68928": { lat: 40.27938, lng: -98.61362 },
  "68731": { lat: 42.4098, lng: -96.48106 },
  "68050": { lat: 41.30711, lng: -96.84113 },
  "68316": { lat: 41.01776, lng: -97.61813 },
  "68122": { lat: 41.36821, lng: -96.05112 },
  "68036": { lat: 41.39078, lng: -96.95177 },
  "68801": { lat: 40.94785, lng: -98.29167 },
  "68861": { lat: 40.70241, lng: -99.25883 },
  "69218": { lat: 42.78883, lng: -101.66748 },
  "68813": { lat: 41.68513, lng: -99.91471 },
  "68405": { lat: 40.76579, lng: -97.07264 },
  "68414": { lat: 40.30462, lng: -95.67043 },
  "69355": { lat: 41.78298, lng: -103.50793 },
  "68458": { lat: 40.23004, lng: -96.50321 },
  "68759": { lat: 42.70517, lng: -99.31385 },
  "68856": { lat: 41.49586, lng: -99.82745 },
  "68127": { lat: 41.20544, lng: -96.05066 },
  "68628": { lat: 41.22073, lng: -97.83968 },
  "69301": { lat: 42.12051, lng: -102.88314 },
  "68860": { lat: 41.1331, lng: -99.79139 },
  "68816": { lat: 41.17739, lng: -98.13296 },
  "69133": { lat: 41.18871, lng: -103.46028 },
  "68351": { lat: 40.65712, lng: -97.42865 },
  "68348": { lat: 40.30611, lng: -96.13923 },
  "68736": { lat: 42.73543, lng: -97.36778 },
  "68037": { lat: 40.98582, lng: -96.12729 },
  "68788": { lat: 41.83971, lng: -96.72148 },
  "68978": { lat: 40.06335, lng: -98.09144 },
  "68323": { lat: 40.14019, lng: -96.38206 },
  "68787": { lat: 42.21441, lng: -97.03474 },
  "68065": { lat: 41.07317, lng: -96.83987 },
  "68939": { lat: 40.10132, lng: -98.96887 },
  "69147": { lat: 41.50657, lng: -102.10098 },
  "68144": { lat: 41.23486, lng: -96.11919 },
  "68822": { lat: 41.38295, lng: -99.63171 },
  "69165": { lat: 41.3071, lng: -101.22877 },
  "68641": { lat: 41.73515, lng: -97.00818 },
  "68431": { lat: 40.06947, lng: -95.43349 },
  "69129": { lat: 41.11253, lng: -102.41746 },
  "68859": { lat: 41.47117, lng: -98.82392 },
  "68401": { lat: 40.73785, lng: -97.59167 },
  "68735": { lat: 42.14366, lng: -98.47554 },
  "68719": { lat: 42.9484, lng: -98.57211 },
  "68440": { lat: 40.05687, lng: -97.00982 },
  "68304": { lat: 40.87932, lng: -96.39239 },
  "69138": { lat: 40.99858, lng: -100.17417 },
  "68512": { lat: 40.73876, lng: -96.70755 },
  "68969": { lat: 40.30383, lng: -99.28345 },
  "68627": { lat: 41.5544, lng: -98.16238 },
  "68124": { lat: 41.23528, lng: -96.05163 },
  "68652": { lat: 41.86969, lng: -98.05189 },
  "68106": { lat: 41.23893, lng: -96.00218 },
  "68382": { lat: 40.5973, lng: -96.02408 },
  "68407": { lat: 40.91922, lng: -96.26654 },
  "68505": { lat: 40.82486, lng: -96.61928 },
  "68310": { lat: 40.25097, lng: -96.74955 },
  "68834": { lat: 41.03164, lng: -99.65885 },
  "68059": { lat: 41.06666, lng: -96.15786 },
  "68755": { lat: 42.92332, lng: -99.12905 },
  "68436": { lat: 40.42383, lng: -97.73942 },
  "68979": { lat: 40.58518, lng: -97.85126 },
  "68658": { lat: 41.19791, lng: -97.29082 },
  "68882": { lat: 41.42785, lng: -98.40025 },
  "68347": { lat: 40.80389, lng: -96.42643 },
  "68416": { lat: 40.41036, lng: -97.45682 },
  "68780": { lat: 42.6428, lng: -99.13364 },
  "68779": { lat: 41.95641, lng: -97.20831 },
  "69216": { lat: 42.9872, lng: -100.98732 },
  "68847": { lat: 40.75891, lng: -99.02572 },
  "68920": { lat: 40.15684, lng: -99.33721 },
  "68655": { lat: 41.65525, lng: -98.25059 },
  "69350": { lat: 41.97744, lng: -101.73279 },
  "69122": { lat: 41.13007, lng: -102.10258 },
  "68117": { lat: 41.20752, lng: -96.00042 },
  "68137": { lat: 41.20586, lng: -96.11886 },
  "68862": { lat: 41.60044, lng: -98.93664 },
  "68872": { lat: 41.09485, lng: -98.33396 },
  "68937": { lat: 40.59087, lng: -99.88136 },
  "69037": { lat: 40.19799, lng: -101.41163 },
  "68133": { lat: 41.11357, lng: -95.99941 },
  "69354": { lat: 42.43668, lng: -103.40774 },
  "68466": { lat: 40.07023, lng: -96.64125 },
  "68763": { lat: 42.50871, lng: -98.60943 },
  "68791": { lat: 41.99204, lng: -96.93641 },
  "68854": { lat: 41.00843, lng: -98.00044 },
  "68792": { lat: 42.73821, lng: -97.12155 },
  "68845": { lat: 40.72731, lng: -99.16299 },
  "68710": { lat: 42.43882, lng: -96.85468 },
  "69001": { lat: 40.24977, lng: -100.64166 },
  "68033": { lat: 41.1307, lng: -96.51674 },
  "68711": { lat: 42.19266, lng: -99.03874 },
  "68317": { lat: 40.67176, lng: -96.50733 },
  "68924": { lat: 40.49565, lng: -99.11905 },
  "68764": { lat: 42.39997, lng: -98.23106 },
  "68372": { lat: 40.60813, lng: -96.60353 },
  "68934": { lat: 40.33931, lng: -98.13834 },
  "68938": { lat: 40.40951, lng: -98.11835 },
  "68647": { lat: 41.52325, lng: -97.62151 },
  "68864": { lat: 41.26306, lng: -98.23505 },
  "68723": { lat: 42.286, lng: -97.21192 },
  "68406": { lat: 40.49989, lng: -97.38536 },
  "68419": { lat: 40.5998, lng: -96.51117 },
  "68745": { lat: 42.44767, lng: -97.08792 },
  "68812": { lat: 40.90115, lng: -99.27942 },
  "69366": { lat: 42.15757, lng: -101.55442 },
  "68927": { lat: 40.50199, lng: -99.62896 },
  "68520": { lat: 40.79968, lng: -96.55148 },
  "68524": { lat: 40.87113, lng: -96.80537 },
  "68773": { lat: 42.36476, lng: -98.1235 },
  "68029": { lat: 41.6609, lng: -96.28274 },
  "69365": { lat: 42.9686, lng: -102.51041 },
  "68368": { lat: 40.55868, lng: -96.82094 },
  "68724": { lat: 42.638, lng: -97.894 },
  "69123": { lat: 41.01217, lng: -100.37252 },
  "68732": { lat: 42.49187, lng: -96.97943 },
  "68866": { lat: 40.97538, lng: -99.12858 },
  "68734": { lat: 42.46905, lng: -98.79604 },
  "69156": { lat: 41.31093, lng: -103.33204 },
  "68841": { lat: 40.75998, lng: -98.17078 },
  "68367": { lat: 41.03581, lng: -97.39728 },
  "69038": { lat: 40.60865, lng: -100.73986 },
  "69039": { lat: 40.69218, lng: -100.38838 },
  "68783": { lat: 42.62072, lng: -98.15211 },
  "68324": { lat: 40.56002, lng: -96.29215 },
  "69331": { lat: 41.87278, lng: -102.98652 },
  "69043": { lat: 40.1355, lng: -101.2325 },
  "68068": { lat: 41.39797, lng: -96.20855 },
  "68136": { lat: 41.16889, lng: -96.18671 },
  "68833": { lat: 41.82838, lng: -100.15389 },
  "68649": { lat: 41.50913, lng: -96.78774 },
  "68357": { lat: 40.31658, lng: -96.55112 },
  "68840": { lat: 40.75845, lng: -98.88117 },
  "68062": { lat: 42.19429, lng: -96.66909 },
  "68315": { lat: 40.24944, lng: -97.54116 },
  "68634": { lat: 41.38989, lng: -97.49306 },
  "68111": { lat: 41.29558, lng: -95.96399 },
  "68404": { lat: 40.61631, lng: -96.75073 },
  "69346": { lat: 42.6874, lng: -103.81099 },
  "68941": { lat: 40.45725, lng: -98.27812 },
  "68879": { lat: 41.90208, lng: -99.54467 },
  "68852": { lat: 41.16459, lng: -99.12629 },
  "68522": { lat: 40.7887, lng: -96.76209 },
  "68883": { lat: 40.81264, lng: -98.59113 },
  "69025": { lat: 40.62265, lng: -100.51307 },
  "68947": { lat: 40.2801, lng: -99.04765 },
  "68463": { lat: 40.87532, lng: -96.13419 },
  "69336": { lat: 41.60962, lng: -103.14127 },
  "68441": { lat: 40.22526, lng: -96.23816 },
  "69120": { lat: 41.39539, lng: -100.22699 },
  "68410": { lat: 40.6375, lng: -95.88476 },
  "69155": { lat: 41.19466, lng: -101.39565 },
  "68320": { lat: 40.48626, lng: -95.95518 },
  "68716": { lat: 41.93314, lng: -96.82297 },
  "68876": { lat: 40.81729, lng: -98.74995 },
  "68849": { lat: 40.70107, lng: -99.104 },
  "68341": { lat: 40.38379, lng: -96.91376 },
  "69022": { lat: 40.35959, lng: -100.18582 },
  "69148": { lat: 41.58567, lng: -102.57943 },
  "68131": { lat: 41.26452, lng: -95.96445 },
  "68977": { lat: 40.0699, lng: -99.63076 },
  "68664": { lat: 41.70403, lng: -96.78645 },
  "68030": { lat: 42.32178, lng: -96.45023 },
  "68041": { lat: 41.24826, lng: -96.49825 },
  "68321": { lat: 40.3924, lng: -95.69082 },
  "68651": { lat: 41.2262, lng: -97.57973 },
  "69134": { lat: 40.83787, lng: -101.36428 },
  "68360": { lat: 40.94549, lng: -96.95509 },
  "68820": { lat: 41.10858, lng: -98.70223 },
  "68742": { lat: 42.35139, lng: -98.51674 },
  "68843": { lat: 40.90455, lng: -97.8853 },
  "68332": { lat: 40.31682, lng: -96.40564 },
  "68336": { lat: 40.96396, lng: -96.68805 },
  "68826": { lat: 41.16361, lng: -98.01551 },
  "68461": { lat: 40.76645, lng: -96.51516 },
  "69033": { lat: 40.56053, lng: -101.6785 },
  "68507": { lat: 40.85892, lng: -96.61486 },
  "68142": { lat: 41.36831, lng: -96.10463 },
  "68422": { lat: 40.39019, lng: -96.69598 },
  "68313": { lat: 40.78197, lng: -97.27235 },
  "68871": { lat: 41.14059, lng: -98.85118 },
  "68789": { lat: 42.54725, lng: -97.97265 },
  "68828": { lat: 41.54885, lng: -99.2354 },
  "68620": { lat: 41.73403, lng: -98.06991 },
  "68502": { lat: 40.78539, lng: -96.69847 },
  "68506": { lat: 40.78388, lng: -96.63864 },
  "68667": { lat: 41.11012, lng: -97.30806 },
  "68642": { lat: 41.69028, lng: -97.51506 },
  "68955": { lat: 40.59454, lng: -98.53927 },
  "68715": { lat: 41.96447, lng: -97.60782 },
  "68362": { lat: 40.15667, lng: -97.44173 },
  "68760": { lat: 42.76551, lng: -98.03095 },
  "68643": { lat: 41.70459, lng: -97.25843 },
  "69211": { lat: 42.82499, lng: -101.29132 },
  "68377": { lat: 40.21421, lng: -97.01842 },
  "68438": { lat: 40.62657, lng: -96.74448 },
  "68375": { lat: 40.03551, lng: -97.45673 },
  "69167": { lat: 41.59477, lng: -101.00348 },
  "69335": { lat: 42.08291, lng: -102.11388 },
  "68453": { lat: 40.41597, lng: -97.3278 },
  "69162": { lat: 41.12789, lng: -103.02521 },
  "68364": { lat: 40.83266, lng: -97.2189 },
  "68448": { lat: 40.55163, lng: -96.02557 },
  "68930": { lat: 40.28849, lng: -98.41415 },
  "68023": { lat: 41.44916, lng: -96.0203 },
  "68346": { lat: 40.66383, lng: -96.02894 },
  "68338": { lat: 40.31047, lng: -97.27153 },
  "68319": { lat: 40.93082, lng: -97.76149 },
  "68740": { lat: 42.15193, lng: -97.30034 },
  "69127": { lat: 41.12368, lng: -101.91067 },
  "68044": { lat: 41.54914, lng: -96.44413 },
  "68105": { lat: 41.2405, lng: -95.96416 },
  "68508": { lat: 40.8183, lng: -96.70587 },
  "68942": { lat: 40.09089, lng: -98.30035 },
  "69021": { lat: 40.13758, lng: -101.54253 },
  "68004": { lat: 42.01242, lng: -96.6321 },
  "69367": { lat: 42.81616, lng: -103.32848 },
  "68815": { lat: 41.41932, lng: -99.14385 },
  "68071": { lat: 42.23568, lng: -96.47117 },
  "68462": { lat: 40.94907, lng: -96.52639 },
  "68621": { lat: 41.48745, lng: -96.6364 },
  "69157": { lat: 42.06169, lng: -100.16159 },
  "68001": { lat: 41.33482, lng: -96.95891 },
  "68014": { lat: 41.28226, lng: -96.96178 },
  "68107": { lat: 41.20841, lng: -95.95167 },
  "68067": { lat: 42.15289, lng: -96.48393 },
  "68730": { lat: 42.77006, lng: -97.54015 },
  "69152": { lat: 42.10926, lng: -101.13245 },
  "68523": { lat: 40.73596, lng: -96.7584 },
  "68838": { lat: 41.2152, lng: -98.66548 },
  "68973": { lat: 40.45228, lng: -98.56397 },
  "68827": { lat: 41.04497, lng: -98.1854 },
  "68881": { lat: 41.43843, lng: -99.35188 },
  "69161": { lat: 42.13836, lng: -100.7693 },
  "68031": { lat: 41.64279, lng: -96.53047 },
  "68349": { lat: 40.82928, lng: -96.29738 },
  "68358": { lat: 40.53148, lng: -96.60805 },
  "68314": { lat: 41.01276, lng: -97.02761 },
  "68756": { lat: 42.19063, lng: -97.98003 },
  "68786": { lat: 42.50576, lng: -97.55664 },
  "69041": { lat: 40.17088, lng: -101.73987 },
  "68421": { lat: 40.49007, lng: -95.74118 },
  "68047": { lat: 42.10665, lng: -96.74049 },
  "68517": { lat: 40.93398, lng: -96.60554 },
  "68950": { lat: 40.46178, lng: -98.66943 },
  "68113": { lat: 41.11759, lng: -95.91126 },
  "68726": { lat: 42.18195, lng: -98.2055 },
  "68379": { lat: 40.51983, lng: -95.86744 },
  "68633": { lat: 41.70515, lng: -96.89691 },
  "69201": { lat: 42.71527, lng: -100.61122 },
  "68873": { lat: 41.24501, lng: -98.45046 },
  "68821": { lat: 42.00951, lng: -99.85778 },
  "68070": { lat: 41.19219, lng: -96.80242 },
  "69135": { lat: 42.24019, lng: -100.25949 },
  "68025": { lat: 41.43794, lng: -96.48933 },
  "68636": { lat: 42.00875, lng: -98.15375 },
  "68777": { lat: 42.86576, lng: -98.69311 },
  "68624": { lat: 41.35174, lng: -97.23428 },
  "68774": { lat: 42.81535, lng: -97.28009 },
  "68865": { lat: 40.8965, lng: -98.18586 },
  "69042": { lat: 40.4767, lng: -100.40524 },
  "68945": { lat: 40.56825, lng: -98.77782 },
  "69345": { lat: 41.5752, lng: -103.74548 },
  "68954": { lat: 40.62267, lng: -98.23737 },
  "68504": { lat: 40.8543, lng: -96.66057 },
  "68532": { lat: 40.79201, lng: -96.84265 },
  "68339": { lat: 40.7337, lng: -96.8646 },
  "68123": { lat: 41.10147, lng: -95.94331 },
  "69343": { lat: 42.69427, lng: -102.01462 },
  "68637": { lat: 41.80528, lng: -98.65848 },
  "68454": { lat: 40.69187, lng: -96.28849 },
  "68112": { lat: 41.37395, lng: -95.9572 },
  "68437": { lat: 40.23166, lng: -95.64577 },
  "68749": { lat: 42.45307, lng: -97.47532 },
  "69348": { lat: 42.28163, lng: -103.31798 },
  "68058": { lat: 41.00875, lng: -96.24832 },
  "69214": { lat: 42.60814, lng: -100.08656 },
  "68034": { lat: 41.4584, lng: -96.21917 },
  "68837": { lat: 41.65982, lng: -99.07658 },
  "68778": { lat: 42.86757, lng: -99.79082 },
  "69036": { lat: 40.04866, lng: -100.27437 }
};

export default ZIP_COORDS;
